import { DataTableEditorService } from '../results/data-table-editor.service';
import { SearchableEntityButtonService } from '../../services/searchable-entity/searchable-entity-button.service';
import { ButtonItem } from '../../button/button.model';
import { AlertService } from 'sce-core';
import { DataTableConfig } from './data-table-config';
import { SEARCH_DEFAULT_PAGE_SIZE } from '../search-constants';

export class SearchParams {

    public tableId: string = '';
    public idProperty: string;
    public isFullFetch: boolean;
    public paginateLocally: boolean = false;
    public defaultPageSize: number = SEARCH_DEFAULT_PAGE_SIZE;
    public columnCount: number;
    public defaultSearchColumn: string;
    public dataTableConfig: DataTableConfig;
    public autoGenerateIdProperty: boolean = true;
    public tableEditor: DataTableEditorService;
    public alertService: AlertService;
    public actionButtons: Array<ButtonItem>;
    public additionalParamMap: any;
    public isAutoSearch: boolean;
    public storerKey: string;
     // array of feilds needs to be hidden in the search filter
    public hiddenPropertiesForFilter: any = [];
    public isSingleSelect: boolean = false;
    public fetchArchiveRecords: boolean = false;
    // [LFWM-2697] - to show and hide populate from archive db checkbox
    public showFetchArchiveRecordsChkBox: boolean = false;
    //[LFWM-3055] -to populate from archive table if any, eg:inv transaction
    public archiveTableId: string ;

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/search/models/search-params.model.ts